
















import { Vue, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { AppBarSettings } from '@/modules/configuration/store/types';
import SettingsButton from '@/modules/configuration/components/SettingsButton.vue';
import Logo from '@/components/Logo.vue';

@Component({
    name: 'AppBar',
    components: { SettingsButton, Logo },
})
export default class AppBar extends Vue {
    @Getter('appBarSettings', { namespace: 'configuration' }) private appBarSettings!: AppBarSettings;

    private get appBar() {
        return this.appBarSettings.visible;
    }
}
